export default __webpack_public_path__ + "static/B13-3815732499d7ab48e5c9902c65045f88.png";